import { getTemplateContent } from "./util";

/**
 * Enhancer of the Job Opening form.
 * Will handle file uploads by uploading directly to S3 using a pre-signed URL, since attachments
 * might be to big to be an AWS Lambda invocation payload. (6MB)
 */
const UPLOAD_ERROR =
  "Uploading your attachment failed. Please try again later.";

const basename = (path) => path.split(/(\\|\/)/g).pop();

const s3putObject = (uri, file) =>
  fetch(uri, {
    method: "PUT",
    body: file,
  });

const populateFileMetadata = (fileInput, s3filename) => {
  const fileParent = fileInput.parentNode;
  fileParent.querySelector(
    '[name="resume-original-filename"]'
  ).value = basename(fileInput.value);
  fileParent.querySelector('[name="resume-s3-filename"]').value = s3filename;
};

const clearError = (fileInput) => {
  const fileParent = fileInput.parentNode;
  fileParent.querySelector(".js-file-error").innerHTML = "";
};

const renderError = (fileInput) => {
  const fileParent = fileInput.parentNode;
  fileParent.querySelector(".js-file-error").innerHTML = UPLOAD_ERROR;
};

const getUploadProcess = (getPresignedUrl) => (fileInput) =>
  fetch(getPresignedUrl, {
    method: "POST",
    mode: "cors",
  })
    .then((response) => response.json())
    .then(({ uri, filename }) =>
      s3putObject(uri, fileInput.files[0]).then((response) =>
        response.status !== 200
          ? Promise.reject(UPLOAD_ERROR)
          : { uri, filename }
      )
    )
    .then(({ uri, filename }) => populateFileMetadata(fileInput, filename))
    .catch((_) => renderError(fileInput));

export const enhancer = (form) => {
  const attachmentsTpl = form.querySelector("#js-attachments-fieldset");
  form.replaceChild(getTemplateContent(attachmentsTpl), attachmentsTpl);

  const uploadFile = getUploadProcess(form.getAttribute("data-s3-upload-url"));

  // Object store for keeping upload promises
  const fileUploads = {};

  // Grab all file type elements
  const fileInputs = [...form.querySelectorAll('input[type="file"]')];
  fileInputs.forEach((fileInput) => {
    // Listen for changes
    fileInput.addEventListener("change", (e) => {
      clearError(fileInput);
      // Push Promise to fileUploads
      fileUploads[fileInput.name] = uploadFile(fileInput);
    });
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const submitButton = form.querySelector("button[type=submit]");
    submitButton.setAttribute("disabled", "disabled");
    submitButton.textContent = "Please wait…";

    // Wait for all file uploads to finish before submitting the form.
    Promise.all(Object.values(fileUploads)).then((_) => {
      form.submit();
    });
  });
};
